import MicroModal from 'micromodal';

const removeModal = (modal) => {
  modal.classList.remove('form-modal__modal--is-open');
};

const setModalHeight = (modal) => {
  const container = modal.querySelector('.hubspot-modal__container');
  if (container) {
    container.style.height = `${container.clientHeight + 1}px`;
  }
};

const hideModalContentOnSuccess = (modal) => {
  window.formVerified = new Event('verified', {bubbles: true});
  modal.querySelector('form').addEventListener('verified', () => modal.querySelector('.form-modal__contents').style.display = 'none');
};

const hubspotModal = {
  init() {
    const hubspotModules = document.querySelectorAll(
      '[data-module="hubspot-modal"]'
    );

    // Checks for availiabilty of hubspot modals on the current page
    if (hubspotModules.length) {
      hubspotModules.forEach((hubspotModal) => {
        hubspotModal.addEventListener('click', (event) => {
          const hubspotModalFormId = hubspotModal.dataset.id;

          // Construct the iframe and open it up
          MicroModal.show(hubspotModalFormId, {
            onShow: (modal) => {
              setModalHeight(modal);
              hideModalContentOnSuccess(modal);
            },
            onClose: (modal) => removeModal(modal),
            openClass: 'form-modal__modal--is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
          });
        });
      });
    }
  },
};

export default hubspotModal;
